import { read } from "@popperjs/core";

window.locale = $('html').attr('lang');

$(function () {
    $('body').stickyHScroll();

    window.initAllOnObject($('body'));

    $(document).on('select2:open', () => {
        setTimeout(() => {
            let searchField = document.querySelector('.select2-container--open .select2-search__field');
            if (searchField) {
                searchField.focus();
            }
        }, 100);
    });

    $(document).on('change', '.custom-file-input', function () {
        let files = $(this)[0].files;
        let output = [];
        for (let i = 0; i < files.length; i++) {
            output.push(files[i].name);
        }

        if (output.length < 1) {
            $(this).parent().find('label').text(translations.Choose_files);
        } else {
            $(this).parent().find('label').text(output.join());
        }
    });

    $(document).on('change', '.file_input', function () {
        let name = $(this).data('name');
        let filesList = $('.selected-files[data-name="' + name + '"]');
        filesList.html('');

        Array.from(this.files).forEach(file => {
            filesList.append('<li>'+file.name+'</li>')
        });
    });

    setTimeout(function () {
        $('.alert alert-danger').remove();
    }, 5000);

    $(document).on('click', '.notifications-btn', function () {
        $('.notifications-div').toggle();
    });

    $('.noficitation-div').each(function () {
        let body = $(this).children('.notification-body');
        let originalText = body.text().trim();
        let readMore = $(this).children('.notification-read-more');

        if (originalText.length > 100) {
            let truncatedText = originalText.slice(0, 125) + '...';
            body.text(truncatedText);

            readMore.on('click', function () {
                if ($(this).hasClass('expanded')) {
                    body.text(truncatedText);
                    $(this).removeClass('expanded');
                    readMore.html(translations.Read_more);
                } else {
                    body.text(originalText);
                    $(this).addClass('expanded');
                    readMore.html(translations.Show_less);
                }
            });
        } else {
            readMore.remove();
        }
    });
});

window.initSelect2 = function(items=false){
    if (items === false) {
        items = $('.select2');
    }    

    items.each(function(index, element){
        let settings = {
            'width': '100%',
        };
        if ($(this).parents('.modal').length > 0) {
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        $(element).select2(settings);
    });
}
window.initSelect2Tags = function(items=false){
    if (items === false) {
        items = $('.select2_tags');
    }

    items.each(function(index, element){
        let settings = {
            'tags': true,
            'width': '100%',
        };
        if ($(this).parents('.modal').length > 0) {
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        if ($(element).data('multiple')) {
            settings['multiple'] = $(element).data('multiple');
        }
            
        $(element).select2(settings);
    });
}
window.initSelect2Ajax = function(items = false) {
    if (items === false) {
        items = $('.select2_ajax');
    }

    items.each(function(index, element) {
        let settingsAttribute = $(element).attr('data-select2-settings');
        let customSettings = JSON.parse(settingsAttribute ?? '{}');

        let defaultSettings = {
            'ajax': {
                'url': $(element).data('url'),
                'data': function(params) {
                    let query = {};
                    query['term'] = params.term; 
                    query['page'] = params.page || 1;

                    let additionalData = $(element).data('additional');
                    if (additionalData !== undefined && additionalData["data_parameters"] !== undefined) {
                        $.each(additionalData["data_parameters"] , function (index, element) {
                            let value = $(element).val();
                            if (value) {
                                query[index] = value;
                            }
                        });
                    }

                    return query;
                }
            },
            'width': '100%',
        };

        let settings = {
            ...defaultSettings,
            ...customSettings
        }

        if ($(element).data('select2-delay')) {
            settings['ajax']['delay'] = $(element).data('select2-delay');
        }
        if ($(this).parents('.modal').length > 0) {
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        if ($(element).data('multiple')) {
            settings['multiple'] = $(element).data('multiple');
        }

        if ($(element).data('maximum-selection-size')) {
            settings['multiple'] = false;
            settings['maximumSelectionSize'] = $(element).data('maximum-selection-size');
        }
        settings['placeholder'] = $(element).data('search-placeholder');
        
        $(element).select2(settings);
    });
}
window.initSelect2AjaxTags = function(items=false){
    if (items === false) {
        items = $('.select2_ajax_tags');
    }

    items.each(function(index, element){
        let settings = {
            'tags': true,
            'ajax': {
                'url': $(element).data('url'),
                'data': function(params){
                    let query = {};
                    if($(element).data('additional') != undefined){
                        query = JSON.parse($(element).data('additional'));
                    }

                    query['term'] = params.term; 
                    query['page'] = params.page || 1;

                    return query;
                }
            },
            'width': '100%'
        };
        if ($(element).data('select2-template-result')) {
            settings['templateResult'] = window[$(element).data('select2-template-result')];
        }
        if ($(element).data('select2-template-selection')) {
            settings['templateSelection'] = window[$(element).data('select2-template-selection')];
        }
        if ($(element).data('select2-delay')) {
            settings['ajax']['delay'] = $(element).data('select2-delay');
        }
        if ($(this).parents('.modal').length > 0) {
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        }

        $(element).select2(settings);
    });
}
window.addressFormatSelectionState = function (item) {
    return $(`<div class="address-result" data-city="${item.city || ''}" data-zipcode="${item.zip_code || ''}")>${item.address || item.text}</div>`);
}

window.initDatePicker = function(items=false){
    if(items === false){
        items = $('.datepicker');
    }

    let complete_locale = window.daterangepicker_locales[window.locale];
    complete_locale['format'] = 'YYYY-MM-DD';

    items.daterangepicker({
        'singleDatePicker': true,
        'autoApply': true,
        'locale': complete_locale
    });

    items.attr('autocomplete', 'off');
}
window.initDateTimePicker = function(items=false){
    if(items === false){
        items = $('.datetimepicker');
    }

    let complete_locale = window.daterangepicker_locales[window.locale];
    complete_locale['format'] = 'YYYY-MM-DD HH:mm';

    items.daterangepicker({
        'singleDatePicker': true,
        'autoApply': true,
        'locale': complete_locale,
        'timePicker': true,
        'timePicker24Hour': true,
    });

    items.attr('autocomplete', 'off');
}
window.initAutonumeric = function(items=false){
    if(items === false)
        items = $('.autonumeric');

    items.each(function(index, element){
        new Autonumeric(element, {
            'decimalCharacter': $(element).attr('data-decimal-character') ? $(element).attr('data-decimal-character') : '.',
            'digitGroupSeparator': $(element).attr('data-thousands-separator') ? $(element).attr('data-thousands-separator') : ' ',
            'decimalPlaces': $(element).attr('data-decimal-places') ? $(element).attr('data-decimal-places') :  2,
        })
    });

    items.attr('autocomplete', 'off');
}

window.initAllOnObject = function(object){
    object = $(object);

    window.initSelect2(object.find('.select2'));
    window.initSelect2Tags(object.find('.select2_tags'));
    window.initSelect2Ajax(object.find('.select2_ajax'));
    window.initSelect2AjaxTags(object.find('.select2_ajax_tags'));
    window.initDatePicker(object.find('.datepicker'));
    window.initDateTimePicker(object.find('.datetimepicker'));
    window.initAutonumeric(object.find('.autonumeric'));
}

function deleteImage(button){
    if (!confirm("{{ trans('validation.Confirm_delete') }}")) {
        return;
    }

    axios.delete($(button).data('url'))
    .then(function () {
        $(button).parent().remove();
    });
}